import { Link } from "react-router-dom";

const UnratedComments = ({ comment }) => {
  return (
    <div className="commentsContent">
      <img src={comment.image} alt="عکس محصول" />
      <div className="addComments">
        <div>
          <span className="name">{comment.name}</span>
          <span className="productPrice">
            {" "}
            {comment?.price?.toLocaleString()} تومان
          </span>
        </div>
        <Link to={`/addComment/${comment.order_id}/${comment.item_id}`}>
          <button className="btn btn--dashcom">ثبت دیدگاه</button>
        </Link>
      </div>
    </div>
  );
};

export default UnratedComments;
